import { Box, Divider, Grid, Text, ReadOnlyField } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import React, { FC } from 'react';

interface SignUpRequestAdministratorDataInfoProps {
  userFirstName: string;
  userLastName: string;
  userFiscalId: string;
  userPhoneNumber: string;
  userEmail: string;
}

const SignUpRequestAdministratorDataInfo: FC<
  SignUpRequestAdministratorDataInfoProps
> = (props) => {
  const { t } = useTranslation();

  const {
    userFirstName,
    userLastName,
    userFiscalId,
    userPhoneNumber,
    userEmail,
  } = props;

  return (
    <>
      <Box mb={6} mt={16}>
        <Text size="md" variant="medium" color="content-primary" mb={4}>
          {t('signUpRequest.administratorData')}
        </Text>
        <Divider />
      </Box>
      <Grid
        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
        gridGap={6}
      >
        <ReadOnlyField label={t('common.user.name')} value={userFirstName} />
        <ReadOnlyField label={t('common.user.lastName')} value={userLastName} />
        <ReadOnlyField
          label={t('common.user.CUIT/CUIL')}
          value={userFiscalId}
        />
        <ReadOnlyField
          label={t('common.user.mobile')}
          value={userPhoneNumber}
        />
        <ReadOnlyField label={t('common.user.email')} value={userEmail} />
      </Grid>
    </>
  );
};

export default SignUpRequestAdministratorDataInfo;
